import { useEffect, useState } from 'react';

const GbitTablePaging = ({
  totalItems,
  itemsPerPage,
  currentPage = 1,
  onPageChange,
}) => {
  const [max, setMax] = useState(0);
  const [now, setNow] = useState(1);
  const [pagingView, setPagingView] = useState([]);

  useEffect(() => {
    setMax(Math.max(1, Math.ceil(totalItems / itemsPerPage)));
  }, [totalItems, itemsPerPage]);

  const createPage = () => {
    let pagingList = [];

    if (totalItems === undefined || totalItems === null || totalItems === 0) {
      totalItems = 1;
    }

    if (max === 1) {
      pagingList = [1];
      setPagingView(pagingList);
      return;
    }

    if (!isNaN(max)) {
      if (max > 5) {
        if (now === 1) {
          pagingList = [now, now + 1, now + 2, now + 3, now + 4];
        } else if (now === 2) {
          pagingList = [now - 1, now, now + 1, now + 2];
        } else if (max - now === 0) {
          pagingList = [now - 4, now - 3, now - 2, now - 1, now];
        } else if (max - now === 1) {
          pagingList = [now - 2, now - 1, now, now + 1];
        } else {
          pagingList = [now - 1, now, now + 1];
        }
      } else {
        for (let i = 0; i < max; i++) pagingList[i] = i + 1;
      }
    }

    setPagingView(pagingList);
  };

  useEffect(() => {
    if (pagingView.length === 0) {
      setPagingView([1]);
    }
  }, [pagingView]);

  const onClick = e => {
    e.preventDefault();
    setNow(parseInt(e.target.id));
    onPageChange(e.target.id);
  };

  const onClickArrow = mode => {
    switch (mode) {
      case 'l':
        onPageChange(now - 1);
        setNow(now - 1);
        break;
      case 'r':
        onPageChange(now + 1);
        setNow(now + 1);
        break;
    }
  };

  useEffect(() => {
    createPage();
  }, [max, now]);

  useEffect(() => {
    setMax(Math.ceil(totalItems / itemsPerPage));
  }, [totalItems, itemsPerPage]);

  useEffect(() => {
    setNow(parseInt(currentPage));
  }, [currentPage]);

  useEffect(() => {
    setPagingView([]);
  }, []);

  return (
    <div className="pagination w-page">
      {now !== 1 && (
        <button
          className="page-navi prev"
          onClick={e => {
            e.preventDefault();
            onClickArrow('l');
          }}
        >
          이전
        </button>
      )}

      <div className="page-links">
        {pagingView.find(item => item === 1) === undefined && (
          <button className="page-link" id={1} onClick={onClick}>
            1
          </button>
        )}
        {pagingView.find(item => item === 1) === undefined &&
          pagingView.find(item => item === 2) === undefined && (
            <span className="page-link link-dot"></span>
          )}
        {pagingView.map(item => {
          if (now === item) {
            return (
              <button
                key={`page-${item}`}
                className="page-link active"
                id={item.toString()}
                onClick={onClick}
              >
                {item}
              </button>
            );
          } else {
            return (
              <button
                key={`page-${item}`}
                className="page-link"
                id={item.toString()}
                onClick={onClick}
              >
                {item}
              </button>
            );
          }
        })}

        {pagingView.find(item => item === max) === undefined &&
          pagingView.find(item => item === max - 1) === undefined && (
            <span className="page-link link-dot"></span>
          )}

        {pagingView.find(item => item === max) === undefined && (
          <button className="page-link" id={max} onClick={onClick}>
            {max}
          </button>
        )}
      </div>

      {now !== max && (
        <button
          className="page-navi next"
          onClick={e => {
            e.preventDefault();
            onClickArrow('r');
          }}
        >
          다음
        </button>
      )}
    </div>
  );
};

export default GbitTablePaging;
